import {weightedCardSchema} from '../../../../../schemas/weightedCardSchema';
import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {
  DTWeightedNode,
  WeightedNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';

export function convertWeightedAPICardToAICard(
  weightedCard: DTWeightedNode,
): z.infer<typeof weightedCardSchema> {
  const candidate: z.input<typeof weightedCardSchema> = {
    ...weightedCard,
    cardId: weightedCard.id,
    type: NodeType.WEIGHTED,
    outputs: weightedCard.outputs.map((output: WeightedNodeOutputData) => ({
      nodeId: output.nodeId ?? 0,
      id: output.id,
      name: output.name ?? '',
      weight: output.weight ?? 0,
    })),
  } as z.infer<typeof weightedCardSchema>;

  return candidate;
}
